// src/screens/YonetimScreen.js
import React, { useState, useCallback, useContext } from 'react';
import {
  View, Text, StyleSheet, ScrollView,
  TouchableOpacity, ActivityIndicator
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import CONFIG from '../config/Config';
import { AuthContext } from '../context/AuthContext';

const DONEMLER = [
  { key: 'bugun',    label: 'Bugün'    },
  { key: 'dun',      label: 'Dün'      },
  { key: 'bu_hafta', label: 'Bu Hafta' },
  { key: 'bu_ay',    label: 'Bu Ay'    },
  { key: 'gecen_ay', label: 'Geçen Ay' },
];

const SEKMELER = [
  { key: 'genel',     label: 'Genel Ciro'      },
  { key: 'cinaralti', label: 'Çınaraltı Dürüm' },
];

const BOS_CIRO = { toplam: 0, nakit: 0, kredi_karti: 0, havale: 0, cari: 0, diger: 0 };
const BOS_DATA = { satis: BOS_CIRO, kasa_girisi: BOS_CIRO, bekleyen_cari: 0 };

function formatTL(val) {
  if (!val && val !== 0) return '—';
  return parseFloat(val).toLocaleString('tr-TR', {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }) + ' ₺';
}

const ActionButton = ({ icon, title, color, onPress, locked = false }) => (
  <TouchableOpacity
    style={[styles.actionButton, locked && { opacity: 0.4 }]}
    onPress={locked ? null : onPress}
    activeOpacity={locked ? 1 : 0.7}
  >
    <View style={[styles.iconContainer, { backgroundColor: locked ? '#B0BEC5' : color }]}>
      <Ionicons name={locked ? "lock-closed" : icon} size={28} color="#fff" />
    </View>
    <Text style={styles.actionText}>{title}</Text>
  </TouchableOpacity>
);

const RevenueRow = ({ icon, color, label, value, isLast }) => (
  <View style={[styles.revenueRow, !isLast && styles.revenueRowBorder]}>
    <View style={styles.revenueRowLeft}>
      <View style={[styles.revenueIcon, { backgroundColor: color + '18' }]}>
        <Ionicons name={icon} size={18} color={color} />
      </View>
      <Text style={styles.revenueRowLabel}>{label}</Text>
    </View>
    <Text style={[styles.revenueRowValue, { color }]}>{value}</Text>
  </View>
);



// ── İki Kutulu Kart (Genel ve Çınaraltı için ortak) ──────────
function CiroKartlari({ satis, kasaGirisi, bekleyenCari, isLoading, hata, onYenile, accentColor }) {
  const color = accentColor || '#2C3E50';

  return (
    <View>
      {/* KUTU 1 — Satış Performansı */}
      <View style={styles.revenueCard}>
        <View style={styles.totalRevenueContainer}>
          <Text style={styles.totalRevenueLabel}>SATIŞ PERFORMANSI</Text>
          {isLoading
            ? <ActivityIndicator size="small" color={color} style={{ marginTop: 12 }} />
            : hata
            ? <Text style={styles.hataText}>{hata}</Text>
            : <Text style={[styles.totalRevenueValue, { color }]}>{formatTL(satis?.toplam)}</Text>
          }
        </View>
        {!isLoading && !hata && (
          <>
            <View style={styles.divider} />
            <View style={styles.revenueList}>
              <RevenueRow
                icon="cash-outline" color="#4CAF50"
                label="NAKİT"
                value={formatTL(satis?.nakit)}
              />
              <RevenueRow
                icon="card-outline" color="#2196F3"
                label="KREDİ KARTI"
                value={formatTL(satis?.kredi_karti)}
              />
              <RevenueRow
                icon="swap-horizontal-outline" color="#FF9800"
                label="HAVALE / EFT"
                value={formatTL(satis?.havale)}
              />
              <RevenueRow
                icon="book-outline" color="#F44336"
                label="CARİ"
                value={formatTL(satis?.cari)}
                isLast
              />
            </View>
          </>
        )}
      </View>

      {/* KUTU 2 — Kasa Girişi */}
      <View style={styles.revenueCard}>
        <View style={styles.totalRevenueContainer}>
          <Text style={styles.totalRevenueLabel}>TAHSİLAT</Text>
          {isLoading
            ? <ActivityIndicator size="small" color={color} style={{ marginTop: 12 }} />
            : hata
            ? <Text style={styles.hataText}>{hata}</Text>
            : <Text style={[styles.totalRevenueValue, { color }]}>{formatTL(kasaGirisi?.toplam)}</Text>
          }
        </View>
        {!isLoading && !hata && (
          <>
            <View style={styles.divider} />
            <View style={styles.revenueList}>
              <RevenueRow
                icon="cash-outline" color="#4CAF50"
                label="NAKİT"
                value={formatTL(kasaGirisi?.nakit)}
              />
              <RevenueRow
                icon="card-outline" color="#2196F3"
                label="KREDİ KARTI"
                value={formatTL(kasaGirisi?.kredi_karti)}
              />
              <RevenueRow
                icon="swap-horizontal-outline" color="#FF9800"
                label="HAVALE / EFT"
                value={formatTL(kasaGirisi?.havale)}
              />

            </View>

            {/* Bekleyen cari uyarısı */}
            {bekleyenCari !== undefined && (
              <View style={[
                styles.bakiyeKutu,
                { backgroundColor: bekleyenCari > 0 ? '#FFF3E0' : '#E8F5E9' }
              ]}>
                <Ionicons
                  name={bekleyenCari > 0 ? "alert-circle-outline" : "checkmark-circle-outline"}
                  size={16}
                  color={bekleyenCari > 0 ? '#FF9800' : '#4CAF50'}
                />
                <Text style={[
                  styles.bakiyeText,
                  { color: bekleyenCari > 0 ? '#FF9800' : '#4CAF50' }
                ]}>
                  {bekleyenCari > 0
                    ? `Bekleyen Tahsilat: ${formatTL(bekleyenCari)}`
                    : 'Tüm satışlar tahsil edildi'}
                </Text>
              </View>
            )}
          </>
        )}

        <TouchableOpacity style={styles.yenileBtn} onPress={onYenile} disabled={isLoading}>
          <Ionicons name="refresh-outline" size={14} color={isLoading ? '#bdc3c7' : '#7f8c8d'} />
          <Text style={[styles.yenileBtnText, isLoading && { color: '#bdc3c7' }]}>Yenile</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

// ── Ana Ekran ────────────────────────────────────────────────
export default function YonetimScreen() {
  const navigation = useNavigation();

  const [aktifDonem,       setAktifDonem]       = useState('bugun');
  const [aktifSekme,       setAktifSekme]       = useState('genel');

  const [genelData,        setGenelData]        = useState(BOS_DATA);
  const [genelLoading,     setGenelLoading]     = useState(false);
  const [genelHata,        setGenelHata]        = useState(null);

  const [cinaraltiData,    setCinaraltiData]    = useState(BOS_DATA);
  const [cinaraltiLoading, setCinaraltiLoading] = useState(false);
  const [cinaraltiHata,    setCinaraltiHata]    = useState(null);

  const { userToken } = useContext(AuthContext);
  const userInfo = userToken ? JSON.parse(userToken) : null;
  const userLevel = userInfo?.Level || 0;

  const fetchGenel = useCallback(async (donem) => {
    setGenelLoading(true);
    setGenelHata(null);
    try {
      const res    = await fetch(`${CONFIG.API_BASE_URL}/ciro?donem=${donem}`, { headers: { 'X-App-Env': CONFIG.ENV } });
      const result = await res.json();
      if (result.success) {
        const satis      = result.satis       ?? BOS_CIRO;
        const kasaGirisi = result.kasa_girisi ?? BOS_CIRO;
        //console.log(kasaGirisi);
        // Bekleyen cari = cari satış - cari tahsilat
        const bekleyenCari = Math.max(
          0,
          round2((satis.cari || 0) - (kasaGirisi.cari || 0))
        );
        setGenelData({ satis, kasa_girisi: kasaGirisi, bekleyen_cari: bekleyenCari });
      } else {
        setGenelHata(result.message);
        setGenelData(BOS_DATA);
      }
    } catch {
      setGenelHata('Sunucuya bağlanılamadı.');
      setGenelData(BOS_DATA);
    } finally {
      setGenelLoading(false);
    }
  }, []);

  const fetchCinaralti = useCallback(async (donem) => {
    setCinaraltiLoading(true);
    setCinaraltiHata(null);
    try {
      const res    = await fetch(`${CONFIG.API_BASE_URL}/ciro/cinaralti?donem=${donem}`, { headers: { 'X-App-Env': CONFIG.ENV } });
      const result = await res.json();
      if (result.success) {
        setCinaraltiData({
          satis:        result.satis        ?? BOS_CIRO,
          kasa_girisi:  result.kasa_girisi  ?? BOS_CIRO,
          bekleyen_cari: result.bekleyen_cari ?? 0,
        });
      } else {
        setCinaraltiHata(result.message);
        setCinaraltiData(BOS_DATA);
      }
    } catch {
      setCinaraltiHata('Sunucuya bağlanılamadı.');
      setCinaraltiData(BOS_DATA);
    } finally {
      setCinaraltiLoading(false);
    }
  }, []);

  const fetchHepsi = useCallback((donem) => {
    fetchGenel(donem);
    fetchCinaralti(donem);
  }, [fetchGenel, fetchCinaralti]);

  useFocusEffect(useCallback(() => {
    fetchHepsi(aktifDonem);
  }, [aktifDonem]));

  const donemDegistir = (key) => {
    setAktifDonem(key);
    fetchHepsi(key);
  };

  return (
    <SafeAreaView style={styles.safeArea} edges={['top', 'left', 'right']}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>Yönetim Paneli</Text>
      </View>

      <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>

        {/* Dönem Butonları */}
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.donemWrapper}
          contentContainerStyle={styles.donemContainer}
        >
          {DONEMLER.map(d => (
            <TouchableOpacity
              key={d.key}
              style={[styles.donemBtn, aktifDonem === d.key && styles.donemBtnActive]}
              onPress={() => donemDegistir(d.key)}
            >
              <Text style={[styles.donemBtnText, aktifDonem === d.key && styles.donemBtnTextActive]}>
                {d.label}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>

        {/* Sekme Seçici */}
        <View style={styles.sekmeContainer}>
          {SEKMELER.map(s => (
            <TouchableOpacity
              key={s.key}
              style={[styles.sekmeBtn, aktifSekme === s.key && styles.sekmeBtnActive]}
              onPress={() => setAktifSekme(s.key)}
            >
              <Text style={[styles.sekmeBtnText, aktifSekme === s.key && styles.sekmeBtnTextActive]}>
                {s.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>

        {/* Kartlar */}
        {aktifSekme === 'genel' ? (
          <CiroKartlari
            satis={genelData.satis}
            kasaGirisi={genelData.kasa_girisi}
            bekleyenCari={genelData.bekleyen_cari}
            isLoading={genelLoading}
            hata={genelHata}
            onYenile={() => fetchGenel(aktifDonem)}
            accentColor="#2C3E50"
          />
        ) : (
          <CiroKartlari
            satis={cinaraltiData.satis}
            kasaGirisi={cinaraltiData.kasa_girisi}
            bekleyenCari={cinaraltiData.bekleyen_cari}
            isLoading={cinaraltiLoading}
            hata={cinaraltiHata}
            onYenile={() => fetchCinaralti(aktifDonem)}
            accentColor="#E53935"
          />
        )}

        {/* İşlem Menüsü */}
        <Text style={styles.sectionTitle}>İşlem Menüsü</Text>
        <View style={styles.actionsGrid}>


<ActionButton icon="wallet"        title="Cari Tahsilat"    color="#4CAF50" locked={userLevel < 2} onPress={() => navigation.navigate('CariTahsilat')} />
<ActionButton icon="storefront"    title="Ürün Yönetimi"    color="#FF9800" locked={userLevel < 3} onPress={() => navigation.navigate('UrunYonetim')} />
<ActionButton icon="people"        title="Müşteri Yönetimi" color="#9C27B0" locked={userLevel < 2} onPress={() => navigation.navigate('MusteriYonetim')} />
<ActionButton icon="globe"        title="Online Mağaza"  color="#4CAF50" locked={userLevel < 2} onPress={() => navigation.navigate('OnlineMagaza')} />
<ActionButton icon="document-text" title="Detaylı Raporlar" color="#607D8B" locked={userLevel < 3}  onPress={() => navigation.navigate('YonetimRaporlar')} />
<ActionButton icon="settings"      title="Sistem Ayarları"  color="#424242" locked={userLevel < 5} onPress={() => navigation.navigate('SistemAyarlari')} />

        </View>

      </ScrollView>
    </SafeAreaView>
  );
}

// Yardımcı
function round2(val) { return Math.round(val * 100) / 100; }

// ── Stiller ──────────────────────────────────────────────────
const styles = StyleSheet.create({
  safeArea:    { flex: 1, backgroundColor: '#F5F7FA' },
  header:      { padding: 15, backgroundColor: '#fff', borderBottomWidth: 1, borderBottomColor: '#ecf0f1' },
  headerTitle: { fontSize: 18, fontWeight: '700', color: '#2c3e50' },
  container:   { padding: 20, paddingTop: 15, paddingBottom: 80 },

  donemWrapper:       { height: 46, flexGrow: 0, flexShrink: 0, marginBottom: 12, marginHorizontal: -20 },
  donemContainer:     { paddingHorizontal: 20, alignItems: 'center', gap: 8 },
  donemBtn:           { paddingHorizontal: 16, height: 36, justifyContent: 'center', backgroundColor: '#E0E6ED', borderRadius: 20 },
  donemBtnActive:     { backgroundColor: '#2C3E50' },
  donemBtnText:       { fontSize: 13, color: '#7F8C8D', fontWeight: '600' },
  donemBtnTextActive: { color: '#fff' },

  sekmeContainer:     { flexDirection: 'row', backgroundColor: '#E8ECF0', borderRadius: 12, padding: 4, marginBottom: 16 },
  sekmeBtn:           { flex: 1, paddingVertical: 9, alignItems: 'center', borderRadius: 9 },
  sekmeBtnActive:     { backgroundColor: '#fff', elevation: 2 },
  sekmeBtnText:       { fontSize: 13, color: '#7F8C8D', fontWeight: '600' },
  sekmeBtnTextActive: { color: '#2C3E50', fontWeight: '700' },

  revenueCard:           { backgroundColor: '#fff', borderRadius: 16, padding: 20, elevation: 4, marginBottom: 16 },
  totalRevenueContainer: { alignItems: 'center', marginBottom: 4 },
  totalRevenueLabel:     { fontSize: 11, color: '#7F8C8D', fontWeight: '700', textTransform: 'uppercase', letterSpacing: 0.8, textAlign: 'center' },
  totalRevenueValue:     { fontSize: 36, fontWeight: 'bold', marginTop: 6 },
  hataText:              { fontSize: 13, color: '#e74c3c', marginTop: 8 },
  divider:               { height: 1, backgroundColor: '#F0F0F0', marginVertical: 10 },
  revenueList:           { marginTop: 2 },
  revenueRow:            { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 9 },
  revenueRowBorder:      { borderBottomWidth: 1, borderBottomColor: '#F7F7F7' },
  revenueRowLeft:        { flexDirection: 'row', alignItems: 'center', gap: 10 },
  revenueIcon:           { width: 34, height: 34, borderRadius: 10, justifyContent: 'center', alignItems: 'center' },
  revenueRowLabel:       { fontSize: 14, color: '#34495E', fontWeight: '500' },
  revenueRowValue:       { fontSize: 15, fontWeight: '700' },
  bakiyeKutu:            { flexDirection: 'row', alignItems: 'center', gap: 8, padding: 12, borderRadius: 10, marginTop: 10 },
  bakiyeText:            { fontSize: 13, fontWeight: '600' },
  yenileBtn:             { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 5, marginTop: 12, paddingTop: 12, borderTopWidth: 1, borderTopColor: '#F0F0F0' },
  yenileBtnText:         { fontSize: 12, color: '#7f8c8d' },

  sectionTitle:  { fontSize: 18, fontWeight: 'bold', color: '#2C3E50', marginBottom: 15 },
  actionsGrid:   { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' },
  actionButton:  { width: '48%', backgroundColor: '#fff', borderRadius: 16, padding: 15, alignItems: 'center', marginBottom: 15, elevation: 2 },
  iconContainer: { width: 50, height: 50, borderRadius: 25, justifyContent: 'center', alignItems: 'center', marginBottom: 10 },
  actionText:    { fontSize: 14, fontWeight: '600', color: '#2C3E50', textAlign: 'center' },
});